import React from 'react';
import { LayersIcon } from 'lucide-react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-blue-100 bg-blue-50 py-14 md:py-16" data-id="element-52" data-mp="3gg1025qei1yp">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-53" data-mp="32ovwwtntqrjm">
        <p className="inline-flex items-center gap-2 text-base font-extrabold uppercase tracking-[0.1em] text-blue-600 md:text-lg md:tracking-[0.14em]" data-id="element-54" data-mp="36p6aardy4k8i">
          <LayersIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-55" data-mp="3uftm3nqzfu0c" />
          +300 Preguntas Visuales de Anatomía Veterinaria
        </p>

        <p className="mx-auto mt-5 max-w-xl text-slate-600" data-id="element-56" data-mp="3lelzi2xtwhm3">
          Material digital · Perros y gatos · Acceso inmediato · Garantía de satisfacción 7 días
        </p>

        <nav aria-label="Enlaces legales" data-id="element-57" data-mp="3qfjfc8vd8zkf">
          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-slate-600" data-id="element-58" data-mp="29yxdbdsefmmc">
            {footerLinks.map(link => <li key={link.label} data-id="element-59" data-mp="2ew71kq41xs8l">
                <a href={link.href} className="rounded transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-blue-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-60" data-mp="3l90lhpgqmmw3">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-10 border-t border-blue-100 pt-6 text-sm text-slate-500" data-id="element-61" data-mp="830j3ija450h">
          © 2026 +300 Preguntas Visuales de Anatomía Veterinaria. Todos los derechos reservados.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-xs leading-relaxed text-slate-500" data-id="element-62" data-mp="322zr2mj94xe">
          Material educativo destinado al estudio y repaso de Anatomía Veterinaria. No reemplaza
          bibliografía oficial, clases, programas académicos ni indicaciones de docentes o
          instituciones educativas.
        </p>
      </div>
    </footer>;
}